import styled from 'styled-components';
import { colors } from '@10d/tend-ui-tokens/samolet';

import { Empty as EmptyAnt } from 'ui/components/Empty';

export const DescriptionsWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const EmptyAntStyled = styled(EmptyAnt)`
  margin-top: 60px;
`;

export const StyledText = styled.div`
  line-height: 24px;
  max-width: 300px;
  font-weight: 400;
  color: ${colors.gray900};
  display: block;
  font-size: 14px;
  font-style: normal;
`;

export const StyledBold = styled.div`
  margin-bottom: 16px;
  margin-top: 9px;
  color: #2d3748;
  font-size: 16px;
  font-weight: 600;
  display: block;
  font-size: 14px;
  font-style: normal;
  line-height: 22px;
`;
